import { combineReducers } from "redux";

import { clearServiceCredentials, setServiceCredentials } from "./service/service";
import {LOG_IN_REQUEST, LOG_IN_SUCCESS, LOG_IN_FAILURE, LOG_OUT} from "./actions";

function authentication(state = { authenticated : false, lastAuthError : false }, action) {
    switch (action.type) {
        case LOG_IN_REQUEST:
            clearServiceCredentials();
            return {
                authenticated: false,
                lastAuthError: false
            };
        case LOG_IN_SUCCESS:
            console.log('user: ' + action.user.firstName + ' ' + action.user.lastName);

            setServiceCredentials(action.user.username, action.user.password);
            return {
                authenticated : true,
                lastAuthError : false,
                username : action.user.username,
                password : action.user.password
            };
        case LOG_IN_FAILURE:
            clearServiceCredentials();
            return {
                authenticated: false,
                lastAuthError: true
            };
        case LOG_OUT:
            clearServiceCredentials();
            return {
                authenticated: false,
                lastAuthError: false
            };
        default:
            return state;
    }
}

/*
 */
export default combineReducers({
    authentication
});



// WEBPACK FOOTER //
// ./src/reducers.js